
<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h2 style='display: inline-block'>Draft Same Threading Search</h2>
        
        <div>
            Use a threading that you enter or upload from a WIF file to find all drafts that have the same threading or turned treadling.<br/><br/>
            Note: For any draft already on Handweaving.net, you can do this by choosing Actions -> Same Threading from the draft's detail page.
        </div>

        <div v-if='!inputMethod' class='rounded-box'>
            <span class='bold'>Input a threading by hand</span> after choosing the numbers of shafts and warp threads in a single unit of the pattern.<br/><br/>
            <b-form-select style='width: auto' v-model="manualEntryShaftsCount" :options='shaftsOptions' />
            <b-form-select style='width: auto' v-model="manualEntryWarpThreadsCount" :options='threadCountOptions' />
            <b-button size='sm' variant='outline-secondary' @click='loadFromManualThreadingEntry()'>Enter Threading <span class="glyphicon glyphicon-search"></span></b-button>
        </div>

        <div v-if='!inputMethod' class='rounded-box'>
            <span class='bold'>Or upload a threading</span> from a WIF file.<br/><br/>
             <file-upload style='vertical-align: middle;' :isImage='false' prompt='Choose WIF File' @fileReceived='loadFromWIF'/>
        </div>

        <div style='margin-top: 1.0rem' v-if='inputMethod && inputMethod==="manual"'>
            Enter one or more complete units of the draft's threading.  Thread 1 is at the right and shaft 1 is at the bottom.
        </div>
        
        <div style='margin-top: 1.0rem' v-if='this.sampleDraft && this.inputMethod'>            
            <div>
                <table class='draftTable' ref='drawdown-table'>
                    <tr>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, false, false)'><ruler :itemsCount='sampleDraft.WarpThreadsCount' startingSide='right' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, false, false)'>
                            <!-- threading -->
                            <grid uniqueCanvasId='threadingGrid' :rowsCount='sampleDraft.ShaftsCount' :columnsCount='sampleDraft.WarpThreadsCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' cellSelectedColor="#000000" cellNotSelectedColor="#ffffff" :rowMajorArray="threading" :singleColumnSelection='false' :singleRowSelection='false' :isReadOnly='!allowDraftEdits' @gridDataChanged = 'onThreadingCellUpdated($event)' :showInverse='false' :renderingKey='threadsRenderingKey'/>
                        </td>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, false, false)'><ruler :itemsCount='sampleDraft.ShaftsCount' startingSide='bottom' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
                    </tr>              
                </table>
            </div>
            <div style='font-size: 1.0rem; margin-top: 0; padding-top:0.2rem; margin-bottom:0; padding-bottom:0.2rem;' v-if='uploadFilename.length > 0'>{{ this.uploadFilename }}</div>            
            <div style='margin-top: 1.0rem;' v-if='inputMethod != null'>
                <b-button size='sm' variant='outline-secondary' @click='loadThreadingSearchResultsPage'>Find Drafts with Same Threading <span class="glyphicon glyphicon-search"></span></b-button>
                <b-button size='sm' variant='outline-secondary' @click='startOverClick'>Start Over</b-button>
            </div>
        </div>
        <div ref='sizingDiv' style="height:0;width:0;outline:none;border:none;padding:none;margin:none;box-sizing:content-box;"></div>
    </b-container>
</template>

<script>
import dataService from '../mixins/dataService.js'
import mediaService from '../mixins/mediaService.js'
import urlsService from '../mixins/urlsService.js'
import utilityService from '../mixins/utilityService.js'
import draftEditorService from '../mixins/draftEditorService.js'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'
import fileUpload from './FileUpload.vue'
import ruler from './Ruler.vue'
import grid from './Grid.vue'
import subscriberLoginPrompt from './SubscriberLoginPrompt.vue'

export default {
    mixins: [dataService, mediaService, urlsService, utilityService, draftEditorService],
    data: function() {
        return {
            threading: null,
            gridBorderColor: '#acacac',
            cellPixelSize: 11,
            borderThicknessPixels: 1,
            threadsRenderingKey: '777',
            sampleDraft: null,
            showLines: true,
            inputMethod: null,
            allowDraftEdits: true,
            lastKnownTouchEvent: null,
            uploadFilename: '',
            threadingHash: 0,
            manualEntryShaftsCount: 4,
            manualEntryWarpThreadsCount: 8,
            shaftsOptions: this.generateNumericOptionsList('4', 4, ' shafts', [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48]),
            threadCountOptions: this.generateThreadCountOptionsList('8', 8, ' warp threads', 200)
        }
    },
    methods: {
        initializeComponent() {
            this.$store.commit('setPageTitle', 'Draft Same Threading Search')
            this.threading=null
            this.gridBorderColor='#acacac'
            this.borderThicknessPixels=1
            this.threadsRenderingKey='777'
            this.uploadFilename = ''

            this.cellPixelSize = this.getRemPixels()

            // load threading
            this.threading = new Array(this.sampleDraft.ShaftsCount)
            this.loadThreadingArrayFromDraftJSON(this.threading, this.sampleDraft)

            // causes threads to rerender when the same WIF file is loaded twice and no other parameter for ColorsArray changes to otherwise cause this
            this.threadsRenderingKey = this.uuidv4()
        },

        onThreadingCellUpdated(rowColObj) {
            // let rowIndex = rowColObj.rowIndex
            // let colIndex = rowColObj.colIndex
            this.drawdownRenderingKey = this.uuidv4()
        },

        loadFromWIF(fileUploadedObj) {
            let wifText = fileUploadedObj.fileContents
            this.postWIFToJSON(wifText).then(resp => {
                let draftToLoad = resp.data
                this.sampleDraft = draftToLoad
                this.initializeComponent()
                this.inputMethod = 'file'
                this.uploadFilename = fileUploadedObj.fileName
            })
        },

        loadThreadingSearchResultsPage() {
            let draftToLoad = null
            if (this.inputMethod === 'file') {
                draftToLoad = this.sampleDraft
            }
            else if (this.inputMethod === 'manual') {
                draftToLoad = this.buildDraftFromThreadingEntry()
            }
            this.$store.commit('setThreadingSearchJSON', draftToLoad)
            this.postJSONToThreadingHash(draftToLoad).then(resp => {
                this.threadingHash = resp.data
                let baseUrl = '/collection-drafts/threading/'
                let query = { patternId: this.patternId, threadingHash: this.threadingHash, isTurned: 0, isStraightened: 0, isPointed: 0, page: 0 }
                this.$router.push({ path: baseUrl, query: query })
            })
        },

        buildDraftFromThreadingEntry() {
            // the threading analyzer to produce the draft hash for the search requires a full draft, but only a threading was entered
            // so this method makes a complete fake draft by copying the threading to the treadling, generating a tieup, and making a set
            // of dark thread colors for the warp and light thread colors for the weft

            let d = {}
            d.ShaftsCount = this.manualEntryShaftsCount
            d.TreadlesCount = d.ShaftsCount
            d.WarpThreadsCount = this.manualEntryWarpThreadsCount
            d.WeftThreadsCount = d.WarpThreadsCount

            // threading
            d.Threading = []
            this.loadDraftJSONFromThreadingArray(this.threading, d)

            d.WarpThreadsCount = d.Threading.length
            d.WeftThreadsCount = d.Threading.length
            d.Treadling = d.Threading

            d.Tieup = []
            for (let treadle=0; treadle <= d.TreadlesCount; treadle++) {
                let shaftsArray = []
                shaftsArray.push(treadle)
                d.Tieup.push(shaftsArray)
            }

            d.WarpThreads = []
            for (let w=0; w < d.WarpThreadsCount; w++) {
                let warpThread = { R: 0, G: 0, B: 0 }
                d.WarpThreads.push(warpThread)
            }

            d.WeftThreads = []
            for (let w=0; w < d.WeftThreadsCount; w++) {
                let weftThread = { R: 255, G: 255, B: 255 }
                d.WeftThreads.push(weftThread)
            }

            console.log('d: ' + JSON.stringify(d))

            return d
        },

        loadFromManualThreadingEntry() {
            this.inputMethod = 'manual'
            this.sampleDraft = { ShaftsCount: this.manualEntryShaftsCount, WarpThreadsCount: this.manualEntryWarpThreadsCount }
            this.sampleDraft.Threading = []
            for (let threadNum=0; threadNum < this.sampleDraft.WarpThreadsCount; threadNum++) {
                let shaftsForThread = new Array(this.sampleDraft.ShaftsCount)
                this.sampleDraft.Threading.push(shaftsForThread)
            }
            this.initializeComponent()
        },

        generateNumericOptionsList(defaultPrompt, defaultValue, appendPromptText, numericValuesArray) {
            let options = []
            // options.push({ text: defaultPrompt + appendPromptText, value: defaultValue })
            for (let c=0; c<numericValuesArray.length; c++) {
                let val = numericValuesArray[c]
                options.push({ text: val + '' + appendPromptText, value: val })
            }
            return options
        },

        generateThreadCountOptionsList(defaultPrompt, defaultValue, appendPromptText, maxThreads) {
            let numericValuesArray = []
            for (let t=1; t <= maxThreads; t++) {
                numericValuesArray.push(t)
            }
            return this.generateNumericOptionsList(defaultPrompt, defaultValue, appendPromptText, numericValuesArray)
        },

        startOverClick() {
            this.inputMethod = null
        }
    },
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        grid: grid,
        fileUpload: fileUpload,
        ruler: ruler,
        subscriberLoginPrompt: subscriberLoginPrompt
    },
    watch: {
    },
    computed: {
    },
    created() {
        this.$store.commit('setPageTitle', 'Weaving Drafts Archive')
    }
}
</script>

<style scoped>

    .rounded-box {
        border-radius: 0.5rem;
        border: 1px solid #cfcfcf;
        padding: 0.5rem;
        vertical-align: top;
        margin-top: 1.0rem;
    }

</style>



// WEBPACK FOOTER //
// src/components/DraftThreadingSearch.vue